const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/visualizations/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { redirectToFirstLoopVisualizationView } from 'src/lib/utils/loop-visualizations/redirectToFirstLoopVisualizationView';
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/visualizations/')({
  loader: async ({
    params,
    context: {
      queryClient
    }
  }) => {
    await redirectToFirstLoopVisualizationView({
      org: params.org,
      loopId: params.loopId,
      queryClient
    });
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});